import { findLastKey, isNull, map, toPairs } from 'lodash-es'
import {
  PR_DISTRIBUTE_THRESHOLDS,
  PrDistributeType,
} from '@/constants/kol-detail/k-score-pr'
import { KpiSchema } from '@/types/schema/kpi-schema'
import { PlatformShortcode } from '@/utils/convert-platform'

const getPrValue = (
  value: number,
  platform: PlatformShortcode,
  prDistributeType: PrDistributeType,
): number => {
  if (value < 0) {
    return 0
  }

  const thresholds = PR_DISTRIBUTE_THRESHOLDS[prDistributeType][platform]

  return parseInt(findLastKey(thresholds, (pr) => value > pr) ?? '0')
}

export const getPrDistributions = (
  kpi: KpiSchema,
  platform: PlatformShortcode,
): number[] => {
  const { follower, fansUpRate3m, interactiveRate3m, avgPv3m, postCount3m } =
    kpi
  const distributeKpiTable: Record<PrDistributeType, number> = {
    [PrDistributeType.FollowLevel]: follower,
    [PrDistributeType.FansUpRate]: isNull(fansUpRate3m) ? 0 : fansUpRate3m,
    [PrDistributeType.FansInteractiveRate]: isNull(interactiveRate3m)
      ? 0
      : interactiveRate3m,
    [PrDistributeType.ViewRate]: isNull(avgPv3m) ? 0 : avgPv3m / follower,
    [PrDistributeType.PublishFrequency]: postCount3m,
  }

  return map(toPairs(distributeKpiTable), ([key, value]) => {
    return getPrValue(value, platform, key as PrDistributeType)
  })
}
